var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"consum-settings-panel"},[(_vm.erpSettingsGroup)?_c('setting-group',{attrs:{"data":_vm.erpSettingsGroup,"visible-codes":_vm.consumVisibleCodes}}):_c('div',{staticClass:"placeholder-message"},[_vm._v(" "+_vm._s(_vm.$t("tools.erp_integration.erp_settings_group_not_found"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }